// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3dKUB","amount":"Amount_amount__3tzXG","tip":"Amount_tip__1jEne","tipHeader":"Amount_tipHeader__2m8H8","tipsWrap":"Amount_tipsWrap__ep1xZ"};